export default "__VITE_ASSET__BNB3bzn9__"